import { useEffect, useState } from "react";
import { Loader2, ImageOff } from "lucide-react";
import { api } from "@/lib/api";

// Stored paths are loaded through the authenticated API (same auth as the rest of the app),
// so they work on mobile/PWA even when the browser blocks cookies on <img> requests.
const blobCache = new Map();
const loadBlobUrl = (path) => {
  if (!blobCache.has(path)) {
    const p = api.get(`/photo/${path}`, { responseType: "blob" })
      .then((res) => URL.createObjectURL(res.data))
      .catch((e) => { blobCache.delete(path); throw e; });
    blobCache.set(path, p);
  }
  return blobCache.get(path);
};

export const ExerciseImage = ({ value, alt, className = "", testId, minHeight }) => {
  const isUrl = !!value && /^(https?:|data:|blob:)/.test(value);
  const [src, setSrc] = useState(isUrl ? value : null);
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let alive = true;
    setLoaded(false); setFailed(false);
    if (!value) { setSrc(null); return undefined; }
    if (isUrl) { setSrc(value); return undefined; }
    setSrc(null);
    loadBlobUrl(value).then((u) => { if (alive) setSrc(u); }).catch(() => { if (alive) setFailed(true); });
    return () => { alive = false; };
  }, [value, isUrl]);

  return (
    <div className="relative w-full h-full" style={!loaded && minHeight ? { minHeight } : undefined}>
      {src && !failed && (
        <img src={src} alt={alt} data-testid={testId} className={`${className} ${loaded ? "" : "opacity-0"}`}
          onLoad={() => setLoaded(true)} onError={() => setFailed(true)} />
      )}
      {!loaded && (
        <div data-testid={testId ? `${testId}-placeholder` : undefined}
          className="absolute inset-0 flex flex-col items-center justify-center gap-1 bg-[#0F1520] text-slate-500">
          {failed ? <ImageOff className="w-5 h-5" /> : <Loader2 className="w-5 h-5 animate-spin" />}
          <span className="text-[10px]">{failed ? "imagem indisponível" : "carregando..."}</span>
        </div>
      )}
    </div>
  );
};
